module.exports = __webpack_public_path__ + "static/media/up-arrow-svgrepo-com (2).e75eba69.svg";